<template>
  <div class="home-banner">
    <swiper :options="swiperOptions">
      <swiper-slide v-for="(item, index) of list" :key="index">
        <div
          class="home-banner-item"
          :class="{ link: item.bannerUrl }"
          @click="openNew(item.bannerUrl)"
          :style="{ 'background-image': 'url(' + item.bannerPic + ')' }"
        ></div>
      </swiper-slide>
      <div class="swiper-pagination" slot="pagination"></div>
      <div class="swiper-button-prev swiper-button" slot="button-prev"></div>
      <div class="swiper-button-next swiper-button" slot="button-next"></div>
    </swiper>
  </div>
</template>

<script>
import { Swiper, SwiperSlide } from "vue-awesome-swiper";
import "swiper/css/swiper.css";
import { getGatewayHomeBannerList } from "@/apiCloud/home";
import { mapGetters } from "vuex";
export default {
  components: {
    Swiper,
    SwiperSlide,
  },
  data() {
    return {
      swiperOptions: {
        loop: true,
        autoplay: {
          //这个参数很重要,当外力干扰轮播图时，它能够继续实现自我滚动
          disableOnInteraction: false,
          delay: 5000, //5秒切换一次
        },
        pagination: {
          el: ".swiper-pagination", //与slot="pagination"处 class 一致
          clickable: true, //轮播按钮支持点击
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      },
      list: [],
    };
  },
  computed: {
    ...mapGetters(["websiteInfo"]),
  },
  created() {
    this.getList();
  },
  methods: {
    getList() {
      getGatewayHomeBannerList({}).then((res) => {
        if (res.code == 200) {
          this.list = res.rows;
        }
      });
    },
    //打开一个新页面
    openNew(url) {
      if (url) {
        window.open(url);
      }
    },
  },
};
</script>

<style lang="less" scoped>
.home-banner {
  .home-banner-item {
    height: 350px;
    background: no-repeat center;
    &.link {
      cursor: pointer;
    }
  }
  .swiper-button {
    color: #fff;
    background: rgba(0, 0, 0, 0.3);
    width: 40px;
    height: 40px;
    border-radius: 50%;
    &:after {
      font-size: 18px;
    }
  }
  .swiper-pagination {
    /deep/ .swiper-pagination-bullet {
      width: 20px;
      height: 4px;
      border-radius: 3px;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/Home3.0/src/Banner.vue